export default __webpack_public_path__ + "static/media/yalda_back2.4851ba64.jpg";